export const isLatinRegexp = /^[a-z\s-]*$/i;
